import { workflowDrivenCacheSyncActionCreator } from '../../workflow-config/utils/store.utils';

export const FILTER_ACTIONS = {
    'SET_CURRENT': 'SET_CURRENT',
    'SET_CURRENT_SELECTED_TAB': 'SET_CURRENT_SELECTED_TAB',
    'STORE_STATE': 'STORE_STATE',
    'RESTORE_STATE': 'RESTORE_STATE',
    'SET_CURRENT_FILTERS': 'SET_CURRENT_FILTERS',
    'SET_APPLIED_FILTER': 'SET_APPLIED_FILTER',
    'SET_APPLIED_FILTER_PROPERTIES': 'SET_APPLIED_FILTER_PROPERTIES',
    'SET_APPLIED_FILTER_CATEGORIES': 'SET_APPLIED_FILTER_CATEGORIES',
    'SET_DEFAULT_CATEGORIES': 'SET_DEFAULT_CATEGORIES',
    'SET_SELECTED_FILTER': 'SET_SELECTED_FILTER',
    'SET_SELECTED_QUERY': 'SET_SELECTED_QUERY',
    'CLEAR_SELECTED_QUERY': 'CLEAR_SELECTED_QUERY',
    'DELETE_APPLIED_FILTER': 'DELETE_APPLIED_FILTER',
};

export const setFilterTypeActionCreator = workflowDrivenCacheSyncActionCreator(FILTER_ACTIONS.SET_CURRENT);
export const setCurrentFiltersActionCreator = workflowDrivenCacheSyncActionCreator(FILTER_ACTIONS.SET_CURRENT_FILTERS);
export const setAppliedFilterActionCreator = workflowDrivenCacheSyncActionCreator(FILTER_ACTIONS.SET_APPLIED_FILTER);
export const setApplieFilterdPropertiesActionCreator = workflowDrivenCacheSyncActionCreator(FILTER_ACTIONS.SET_APPLIED_FILTER_PROPERTIES);
export const setAppliedFilterCategoriesActionCreator = workflowDrivenCacheSyncActionCreator(FILTER_ACTIONS.SET_APPLIED_FILTER_CATEGORIES);
export const setDefaultCategoriesActionCreator = workflowDrivenCacheSyncActionCreator(FILTER_ACTIONS.SET_DEFAULT_CATEGORIES);
export const setCurrentSelectedFilterActionCreator = workflowDrivenCacheSyncActionCreator(FILTER_ACTIONS.SET_SELECTED_FILTER);
export const setCurrentSelectedQueryActionCreator = workflowDrivenCacheSyncActionCreator(FILTER_ACTIONS.SET_SELECTED_QUERY);
export const clearCurrentSelectedQueryActionCreator = workflowDrivenCacheSyncActionCreator(FILTER_ACTIONS.CLEAR_SELECTED_QUERY);
export const deleteAppliedFilterActionCreator = workflowDrivenCacheSyncActionCreator(FILTER_ACTIONS.DELETE_APPLIED_FILTER);
